<template>
    <v-container class="pa-0 ma-0" fluid>
			<v-row class="px-0 my-2">
        <v-col class="pb-0">
          <v-file-input 
            dense
            :loading="uploading" 
            show-size 
            label="Archivo" 
            v-model="file"
            :rules="rulesFiles"
          >
          </v-file-input>
        </v-col>
        <v-col class="pb-0">
          <v-btn color="primary" dark class="mb-2" @click="uploadFile" :loading="uploading">Subir</v-btn>
        </v-col>
				<v-col cols=12 >
          <v-data-table
            dense
            :headers="headers"
            :items="items"
            class="elevation-2"
            hide-default-header
            hide-default-footer
            disable-pagination
           
            :mobile-breakpoint=100
          >
            <template v-slot:header="{props}">
              <tr >
                  <td
                    v-for="header in props.headers"
                    :key="header.text"
                    class="text-truncate body-2 primary white--text "
                    :class="header.class "
                    :align="header.align"
                    :width="header.width"
                    v-text="header.text"
                  />
              </tr>
            </template>

            <template v-slot:item="{item,isSelected,select,headers} ">
              <tr class="body-2">
                <template v-for="(h, idx) in headers" >
                  <td v-if="h.value=='ext'" :align="h.align" :class="['body-2', h.class]"  :key="idx">
                    <v-icon small class="mx-3">
                      {{item[h.value] | iconizar}}
                    </v-icon>
                  </td>
                  <td v-else-if="h.value=='actions'" :align="h.align" :class="['body-2', h.class]" :key="idx">
                    <v-icon small class="mx-3" @click="deleteItem(item)">fa fa-trash-o</v-icon>
                  </td>
                  <td v-else :align="h.align" :class="['body-2', h.class]" v-text="item[h.value]" :key="idx" />
                  
                </template> 

              </tr>
            </template>
          </v-data-table>
        </v-col>

      </v-row>
    </v-container>
</template>
<script>
  import {mapGetters} from 'vuex'

  export default {
    name: 'ListasPrecios',

    components: {
      
    },

    data: () => ({

      file:undefined,
      uploading:false,
      rulesFiles: [
        value => {
          if (!value) return 'Debe selecionar un archivo'
          else  if(value.size > 12000000) return 'El archivo debe ser más pequeño, máximo 12 MB!'
          return true
          },
      ],

      headers: [
        { text: 'Tipo'  ,align: 'center',sortable: false, value: 'ext' },
        { text: 'Lista' ,align: 'start',sortable: false, value: 'name'},
        { text: 'Fecha' ,align: 'start',sortable: false, value: 'data'},
        { text: ''      ,align: 'center'  ,sortable: false, value: 'actions', width:"60px" },
      ],
      items:[],
    }),
    created: function () {
      console.log("Componente creado")
      //this.initialize()
    },
    mounted: function () {
      console.log("Componente mondado")
      this.loadItems()
    },

    filters:{
      iconizar:  (arr) => {
        console.log(arr)
        let icon="fa fa-file-o"
        switch (arr) {
          case "doc":
          case "docx":
            icon="fa fa-file-word-o"
            break;
          case "xls":
          case "xlsx":
            icon="fa fa-file-excel-o"
            break;
          case "pdf":
            icon="fa fa-file-pdf-o"
            break
          case "txt":
            icon="fa fa-file-text-o"
            break
        }
        return icon
      },

    },
    watch: {

    },

    methods: {
      initialize () {},
        
      async uploadFile (){
        console.log("UPLOAD")
        this.uploading=true

        let formData = new FormData()
        formData.append('file',this.file)

        let opt={
            method: 'PUT', 
            mode: 'cors',
            body: formData,

          }
        let response = await fetch(`${this.ROOT_API}cms/upload/listas`, opt);
        if (response.ok) {
          console.log(await response.json())
          this.loadItems()
          this.uploading=false
        }else {
          console.log("error")
          this.uploading=false
        }
      },

      async deleteFile(file){
        console.log("DELETE FILE")

        let opt={
          method: 'DELETE', 
          mode: 'cors',
        }
        let response = await fetch(`${this.ROOT_API}cms/upload/listas/${file.name}`, opt);
        if (response.ok){
          this.loadItems()
        }

      },

      deleteItem (item) {
        
        if (confirm('Seguro que desea eliminar el item seleccionado?')) { 
          this.deleteFile(item) 
        }
      },

      async loadItems (){
        let opt={
            method: 'GET', 
            mode: 'cors'
          }
        let response = await fetch(`${this.ROOT_API}lst_precios`, opt);

        if (response.ok){
          let r=await response.json()
          
          this.items=r.data
        }

      },
    },
    computed: {
      ...mapGetters(['SESSION','ROOT_API']),
    },
  }
</script>

<style scoped>

</style>
